/** Menyularda "Profilni ochish": ochish va ruxsat (canOpenPerson) birga uzatiladi. */
import { UserRound } from "lucide-react";
import type { MenuItem } from "@/components/ui/context-menu";
import type { Translate } from "@/features/drivers/menu";

export interface ProfileAction {
  open: (id: number) => void;
  can: (id: number, role?: string | null) => boolean;
}

/** Ruxsat bo'lsa menyu bandi, bo'lmasa false (compactMenu tashlab yuboradi) */
export function profileItem(profile: ProfileAction | undefined, id: number | null | undefined, t: Translate, opts: { name?: string; role?: string | null; key?: string } = {}): MenuItem | false {
  if (!profile || !id || !profile.can(id, opts.role)) return false;
  return {
    key: opts.key ?? "profile",
    label: opts.name ? t("openPersonProfile", { name: opts.name }) : t("openProfile"),
    icon: UserRound,
    onSelect: () => profile.open(id),
  };
}
